import styled from "styled-components";

export const CatalogContainer = styled.div`
  width: 100%;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

interface CatalogHeaderBanner {
  bgImagen?: string;
}

export const CatalogHeaderBanner = styled.div`
  background-image: url(${(p: CatalogHeaderBanner) =>
    p.bgImagen ? p.bgImagen : ""});
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: local;
  background-size: cover;
  width: 100%;
  height: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

interface CatalogHeaderBannerTitle {
  textColor?: string;
}

export const CatalogHeaderBannerTitle = styled.h1`
  color: ${(p: CatalogHeaderBannerTitle) =>
    p.textColor ? p.textColor : "var(--color-menu-bg)"};
  font-size: 3rem;
  font-weight: 600;
  font-family: MontserratRegular;
`;

interface CatalogElementContainer {
  bg?: string;
}

export const CatalogElementContainer = styled.div`
  background-color: ${(p: CatalogElementContainer) =>
    p.bg ? p.bg : "var(--color-menu-bg)"};
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  padding-bottom: 3rem;
  overflow-y: scroll;
  position: relative;
`;

interface CatalogElementContainerBlock {
  bg?: string;
}

export const CatalogElementContainerBlock: any = styled.div`
  background-color: ${(p: CatalogElementContainerBlock) =>
    p.bg ? p.bg : "var(--color-menu-bg)"};
  width: 100%;
  height: fit-content;
  box-shadow: 0px 3px 6px #00000029;
  border: 3px solid #9c94947f;
  border-radius: 34px;
  margin-top: 1rem;
  margin-bottom: 5rem;
  display: block;
  position: relative;
`;
